import _ from 'underscore'
import Types from '../../../actions/Types'

const initialState = {
  isFetching: false,
  data: null,
  error: null
}

export default (state = initialState, action = null) => {
  switch (action.type) {
    case Types.AUTH.PASSWORD.FETCH:
      return _.extend({}, state, {
        isFetching: true,
        data: action.data,
        error: null
      })
    case Types.AUTH.PASSWORD.SUCCESS:
      return _.extend({}, state, {
        isFetching: false,
        error: null
      })
    case Types.AUTH.PASSWORD.ERROR:
      return _.extend({}, state, {
        isFetching: false,
        error: action.error
      })
    case Types.APP.CLEARERROR:
      return (
        _.isUndefined(action.api)
        ||
        action.api === Types.AUTH.PASSWORD
      )
        ? _.extend({}, state, {
            error: null
          })
        : state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/root/app/password.js